export default __webpack_public_path__ + "static/media/Talent_FarOutMan.3481a411.png";